// Actions

import { createSlice } from "@reduxjs/toolkit";
import { uniqueId } from "lodash";

import { AppDispatch } from "../store";

const NAME = "notifications";

export interface AppNotification {
  id: string;
  message: string;
  color: string;
  autoClose: boolean;
  seeMoreContent?: () => JSX.Element;
}

const initialState: AppNotification[] = [];

const notificationsSlice = createSlice({
  name: NAME,
  initialState,
  reducers: {
    createNotification: (state, action) => {
      state.push(action.payload);
    },
    removeNotification: (state, action) => {
      const index = state.findIndex(
        (notification) => notification.id === action.payload
      );
      if (index !== -1) {
        state.splice(index, 1);
      }
    },
  },
});

export const createNotification =
  (
    message: string,
    color: string,
    autoClose?: number,
    seeMoreContent?: () => JSX.Element
  ) =>
  (dispatch: AppDispatch) => {
    const id = uniqueId();

    const notification = {
      id,
      message,
      color,
      autoClose: !!autoClose,
      seeMoreContent,
    };

    dispatch(notificationsSlice.actions.createNotification(notification));

    if (!!autoClose) {
      setTimeout(() => {
        dispatch(notificationsSlice.actions.removeNotification(id));
      }, autoClose);
    }
  };

export const { removeNotification } = notificationsSlice.actions;

export default notificationsSlice.reducer;
